import {FormEvent} from 'react'

import {useMutation} from "@apollo/client";
import {CREATE_ESTIMATION, CreateEstimationQuery} from "@App/graphql/mutations/createEstimation";
import {useSelector} from "react-redux";
import {State} from "@App/state";


export const useCreateEstimation = ({
                                        email,
                                        phone,
                                        tos,
                                        marketing,
                                    }) => {
    const [createEstimation, {loading, data, error}] = useMutation<CreateEstimationQuery>(CREATE_ESTIMATION)

    const organization = useSelector((state: State) => state.orders.organization)
    const service = useSelector((state: State) => state.orders.service)
    const motorization = useSelector((state: State) => state.orders.motorization)

    const submit = (e: FormEvent) => {
        e.preventDefault();
        createEstimation({
            variables: {
                organization: organization.id,
                services: service ? [service.id] : null,
                email: email,
                phone: phone.number ? phone.country + parseInt(phone.number) : null,
                tos: tos,
                marketing: marketing,
                motorization: motorization ? motorization.id : null,
            }
        }).then((response) => {
            console.log('estimation created')
        }).catch((error) => {
            console.log(error)
        })
    }

    const hasValidationError = (value: string): boolean => {
        return error.graphQLErrors.some(error => error.message.includes(value)
            || error.extensions.validation && 'input.' + value.replace('$', '') in error.extensions.validation)
    }

    return {
        error,
        loading,
        estimation: data ? data.createEstimation : null,
        validationErrors: {
            ...error && hasValidationError('$email') && {email: true},
            ...error && hasValidationError('$tos') && {tos: true},
        },
        submit
    }
}
